var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('lottie',{staticClass:"m-0",attrs:{"width":_vm.width,"height":_vm.heigh,"options":_vm.lottieOptions},on:{"animCreated":_vm.handleAnimation}})}
var staticRenderFns = []

export { render, staticRenderFns }